import { Flex, Image, Text } from "@chakra-ui/react";
import LogoIcon from "@/assets/logo.png";
import LogoText from "./assets/logo-text.png";
import { LogsButton } from "@/components/Button";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import { useEffect } from "react";
import { useAccount } from "wagmi";
import { useLocation, useNavigate } from "react-router-dom";
import Bg from "./assets/bg.png";
import LocalCurrency from "../userHome/LocalCurrency";

const Login = () => {
  const { openConnectModal } = useConnectModal();
  const navigate = useNavigate();
  const location = useLocation();
  const { isConnected } = useAccount();

  useEffect(() => {
    if (isConnected) {
      // 获取 URL 参数
      const params = new URLSearchParams(location.search);
      const returnUrl = params.get("returnUrl");

      if (returnUrl) {
        navigate(decodeURIComponent(returnUrl));
      } else {
        navigate("/"); // 没有 returnUrl 时跳转到首页
      }
    }
  }, [isConnected, navigate, location.search]);

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      height="100%"
      sx={{
        backgroundImage: `url(${Bg})`,
        backgroundPosition: "center",
      }}
      flexDir={"column"}
    >
      <Image src={LogoIcon} alt="Logo" width={"60px"} />
      <Image
        src={LogoText}
        sx={{
          width: "74px",
          marginTop: "12px",
        }}
      ></Image>
      <Text
        sx={{
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 400,
          color: "#333",
          fontFamily: "DIN-LightItalic",
          marginTop: "12px",
        }}
      >
        Smartest Way to Pay
      </Text>
      <LogsButton
        onClick={openConnectModal}
        variant="outlined"
        sx={{
          fontSize: "20px",
          fontWeight: 700,
          marginTop: "24px",
          border: "1px solid #fff",
        }}
      >
        Connect Wallet
      </LogsButton>
    </Flex>
  );
};

export default Login;
